export default __webpack_public_path__ + "static/media/GWAS.0a028b96.svg";